import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/containers/specifics/vendors/settings/company_settings/[id]/construction_item_settings/Page";

export const PATH = (companyMasterId: number): string =>
	`/vendors/settings/company_settings/${companyMasterId}/construction_item_settings`;

function CompanySetting() {
	const router = useRouter();
	const { companyMasterId = null } = router.query;

	return (
		<>
			<NskHead title="単価一覧" />
			<VendorLayoutV2>
				{companyMasterId === null ? null : (
					<Component companyMasterId={Number(companyMasterId)} />
				)}
			</VendorLayoutV2>
		</>
	);
}
export default CompanySetting;
